import React from 'react';
import * as FPT from '../utility/fpt';
import { CaptionText, BodyText } from '@paypalcorp/pp-react';
import getSocialCampaign from '../utility/getSocialCampaign';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import SocialShare from '../components/socialShare/socialShare';

const { label: copyLinkMessages } = localsMessages('common/copyLink');
const { title = {} } = localsMessages('common/socialShareMessage');

export default function ConfirmationSocialShare(props) {
  const {
    email,
    hostedButtonId,
    orgName,
    messages: { social },
  } = props;
  const { copy, copied } = copyLinkMessages;
  const handleSocialAnalytics = (type) => {
    FPT.trackLinkClick(type);
  };

  let socialMessages;

  if (hostedButtonId) {
    socialMessages = {
      ...social,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
    };
  } else {
    socialMessages = {
      ...social,
      ...social.unhosted,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
    };
  }

  const socialCampaign = getSocialCampaign(
    socialMessages,
    orgName,
    hostedButtonId,
    title,
    email
  );

  const generateSocialShareUrl = () => {
    if (hostedButtonId) {
      return `https://www.paypal.com/donate/?hosted_button_id=${hostedButtonId}&source=url`;
    } else if (email) {
      return `https://www.paypal.com/donate/?business=${email}&source=url`;
    }
  };

  const socialShareUrl = generateSocialShareUrl();

  return (
    <>
      <BodyText className="text-center social_share_header">
        {social.copyLinkHeader}
      </BodyText>
      <CaptionText className="text-center social_share_subheader">
        {social.subheader}
      </CaptionText>
      <SocialShare
        shareUrl={socialShareUrl}
        socialCampaign={socialCampaign}
        isMobile={TemplateData.ismobile}
        analytics={handleSocialAnalytics}
      />
    </>
  );
}
